import { ListItemLink } from "./ListItemLink";
import { List, Toolbar } from "@mui/material";
import { useIntl } from "react-intl";
import AssessmentIcon from "@mui/icons-material/Assessment";
import HelpIcon from "@mui/icons-material/Help";

export const MainMenu: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      <Toolbar />
      <List sx={{ pt: "56px" }}>
        <ListItemLink
          primary={intl.formatMessage({ id: "menu.reports" })}
          to={"/reports"}
          icon={<AssessmentIcon />}
        />
        <ListItemLink
          primary={intl.formatMessage({ id: "menu.help" })}
          to={"/help"}
          icon={<HelpIcon />}
        />
      </List>
    </>
  );
};
